// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radioGroup-root-LZC {\n    display: none;\n}\n\n.radioGroup-radioContainer-isH {\n    grid-template-areas: 'input label';\n    grid-template-columns: -webkit-min-content 1fr;\n    grid-template-columns: min-content 1fr;\n}\n\n.radioGroup-message-yQO {\n}\n\n/* TODO @TW: cannot compose */\n.radioGroup-message-yQO:empty {\n    display: none;\n}\n\n@media screen and (max-width: 991px) {\n    .radioGroup-root-LZC > div {\n        grid-template-columns: 1fr;\n    }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "radioGroup-root-LZC gap-2xs grid",
	"radioContainer": "radioGroup-radioContainer-isH gap-3 grid grid-flow-col justify-center leading-normal",
	"message": "radioGroup-message-yQO mt-xs text-colorDefault"
};
export default ___CSS_LOADER_EXPORT___;
